import React from 'react';
import KnowledgeGraph from './KnowledgeGraph';

const Essay = () => {
  return (
    <div className="space-y-6">
      {/* Knowledge Graph Content */}
      <KnowledgeGraph />
    </div>
  );
};

export default Essay; 